document.addEventListener("DOMContentLoaded", function () {
    // 1. Reusable Scroll Function
    const scrollToHeading = (triggerElement, value) => {

      const generateSlug = (text) => {
      if (!text) return "";
      return text
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9 ]/g, "")
        .replace(/\s+/g, "-");
    };

    let targetSlug;

    // 3. Logica om de slug te bepalen
    if (value && value.includes("#reviews")) {
      // Gebruik de URL constructor om de hash veilig te pakken
      const url = new URL(value, window.location.origin);
      targetSlug = generateSlug(url.hash); // Dit wordt "reviews"
    } else {
      const searchTerm =
        triggerElement.innerText ||
        (triggerElement.options && triggerElement.options[triggerElement.selectedIndex].text);

      targetSlug = generateSlug(searchTerm);
    }


    // Update URL bar
    history.pushState(null, null, `#${targetSlug}`);

    // Find the matching .h3 element
    const headings = document.querySelectorAll(".h3");
    let targetElement = null;

    headings.forEach((h) => {
      const headingSlug = generateSlug(h.innerText);
      if (
        headingSlug.includes(targetSlug) ||
        targetSlug.includes(headingSlug)
      ) {
        targetElement = h;
      }
    });

    if (targetElement) {
      const headerOffset = 110;
      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  // 2. Handle Desktop Clicks (Anchors)
  document.addEventListener("click", function (e) {
    const link = e.target.closest("a");
    if (!link) return;

    const url = new URL(link.href, window.location.origin);

    // Split the path, remove empty strings (from trailing slashes), and grab the last two
    const lastTwoSegments = url.pathname.split('/').filter(Boolean).slice(-2);

    // If you want them as a string (e.g., "pages/about")
    const segmentsPath = lastTwoSegments.join('/');

    //console.log(lastTwoSegments); // Array: ["pages", "about"]
    //console.log(segmentsPath);    // String: "pages/about"

    if (
      window.location.pathname.includes("/"+segmentsPath) &&
      url.pathname.includes("/"+segmentsPath)
    ) {
      if (!url.hash) return;
      e.preventDefault();
      scrollToHeading(link, link.href);
    }
  });

  // 3. Handle Mobile Dropdown (Select)
  const mobileSelect = document.querySelector(".quick-nav-select");
  if (mobileSelect) {
    // Remove the inline 'onchange' to prevent page reloads
    mobileSelect.removeAttribute("onchange");

    mobileSelect.addEventListener("change", function (e) {
      const selectedValue = this.value;
      if (
        window.location.pathname.includes("/pages/about") &&
        selectedValue.includes("/pages/about")
      ) {
        scrollToHeading(this, selectedValue);
      } else {
        // Fallback: If navigating to a different page entirely
        window.location.href = selectedValue;
      }
    });
  }
});

// Update document.title when a variant changes on the product page.
// Mirrors the Liquid title format in layout/theme.liquid:
//   {product_title} - {color} frame with {lens_color} {product_type} lenses
document.addEventListener("variant:change", function (event) {
  const variant = event.detail?.variant;
  if (!variant) return;

  // Only run on product pages – bail out if no variant-picker present
  const variantPicker = document.querySelector("variant-picker");
  if (!variantPicker) return;

  // Read the product options JSON so we can match option names to values
  let productOptions = [];
  try {
    const optionsScript = variantPicker.querySelector(
      "script[data-product-options]",
    );
    if (optionsScript) productOptions = JSON.parse(optionsScript.textContent);
  } catch (e) {}

  // Build a name→value map for this variant's options
  const optionMap = {};
  productOptions.forEach((opt, i) => {
    optionMap[opt.name.toLowerCase()] = variant.options?.[i] ?? "";
  });

  // Base product title: everything before the first " - " in the current title,
  // falling back to the h1 text if the title hasn't been modified yet.
  const h1 = document.querySelector("h1");
  const baseTitle =
    h1?.textContent?.trim() || document.title.split(" - ")[0].trim();

  // Find color option (frame color, not lens color)
  let colorValue = "";
  for (const [name, value] of Object.entries(optionMap)) {
    if (name.includes("color") && !name.includes("lenses")) {
      colorValue = value;
      break;
    }
  }

  // Find lens color option
  let lensValue = "";
  for (const [name, value] of Object.entries(optionMap)) {
    if (name.includes("lenses") && name.includes("color")) {
      lensValue = value;
      break;
    }
  }

  // Get product type from a meta tag or existing title segment
  const productTypeMeta = document.querySelector('meta[property="og:type"]');
  // product.type is not in a standard meta – read it from a data attribute we can embed,
  // or fall back to extracting it from the original server-rendered title.
  const originalTitle = document.title;
  const lensesMatch = originalTitle.match(/with\s+\S+\s+(.+?)\s+lenses/i);
  const productType = lensesMatch ? lensesMatch[1] : "";

  // Reconstruct the title
  let newTitle = baseTitle;
  if (colorValue) newTitle += ` - ${colorValue} frame`;
  if (lensValue && productType)
    newTitle += ` with ${lensValue} ${productType} lenses`;
  else if (lensValue) newTitle += ` with ${lensValue} lenses`;

  document.title = newTitle;
});
